import { create } from 'zustand'

interface ListStore {
  isShoppingMode:  boolean
  setShoppingMode: (value: boolean) => void
}

export const useListStore = create<ListStore>(set => ({
  isShoppingMode:  false,
  setShoppingMode: value => set({ isShoppingMode: value }),
}))
